import { render } from "./MultipassApprovers.vue?vue&type=template&id=77ed150c"
import script from "./MultipassApprovers.vue?vue&type=script&lang=js"
export * from "./MultipassApprovers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__